(function() {
    'use strict';
    angular
        .module('capacitacionCertificacionApp')
        .factory('Course', Course);

    Course.$inject = ['$resource', 'DateUtils'];

    function Course ($resource, DateUtils) {
        var resourceUrl =  'api/courses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                        data.lastChangedDate = DateUtils.convertDateTimeFromServer(data.lastChangedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
